export const PURPLE = "#5865E0";
export const LIGHT_GREY = "#F5F6F8";
export const WHITE = "#FFFFFF";
export const DARK_BLUE = "#131822";
export const LIGHT_BLUE = "#19212D";
